/**
 * Home page — CMS-driven mission, cards, aims, CTA, and news teaser.
 */
(function () {
  'use strict';

  async function init() {
    await window.Troop936Content?.applySiteSettings?.();

    await window.Troop936Content?.renderPageBlocks?.([
      { slug: 'home-mission', elId: 'content-home-mission' },
      { slug: 'home-aims', elId: 'content-home-aims' },
      { slug: 'home-cta-band', elId: 'content-home-cta-band' },
    ]);

    const newsEl = document.getElementById('home-news');
    const items = await window.Troop936Content.loadAnnouncements(3);
    newsEl?.classList.remove('is-loading');

    if (!newsEl) return;

    if (!items.length) {
      newsEl.innerHTML = '<p class="muted">No announcements right now. <a href="calendar.html">Check the calendar</a> for upcoming events.</p>';
      return;
    }

    newsEl.innerHTML =
      items
        .map(
          (a) => `
        <article class="news-teaser-item">
          <time>${formatDate(a.published_at || a.created_at)}</time>
          <h3><a href="news.html">${escapeHtml(a.title)}</a></h3>
          <p>${escapeHtml(a.body.slice(0, 140))}${a.body.length > 140 ? '…' : ''}</p>
        </article>
      `
        )
        .join('') + '<p><a href="news.html">View all announcements →</a></p>';
  }

  function formatDate(iso) {
    try {
      return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
    } catch {
      return '';
    }
  }

  function escapeHtml(str) {
    const d = document.createElement('div');
    d.textContent = str || '';
    return d.innerHTML;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

export {};
